import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { SymbolConnector } from '@/features/legends/symbols/components/SymbolConnector'
import type { SymbolConnectorViewModel } from '@/features/legends/symbols/SymbolConnectorViewModel'

export interface SymbolConnectorContainerProps {
  vm: SymbolConnectorViewModel
  isDisabled?: boolean
  placeholder?: string
  /**
   * Extra buttons in the input. See `SymbolConnectorAction`.
   */
  actions?: ReactNode
  'aria-label'?: string
  testId?: string
}

export const SymbolConnectorContainer = observer(
  function SymbolConnectorContainer({
    vm,
    isDisabled,
    placeholder,
    actions,
    'aria-label': ariaLabel,
    testId,
  }: SymbolConnectorContainerProps) {
    return (
      <SymbolConnector
        options={vm.availableEntityDescriptors.map((d) => ({
          id: d.entity.id,
          kind: d.type,
          valueType: d.entity.valueType ?? null,
        }))}
        value={vm.symbolId}
        searchText={vm.searchText}
        onSearchTextChange={vm.setSearchText}
        onChange={vm.setSymbolId}
        onShowAll={vm.clearSearch}
        focus$={vm.focus$}
        actions={actions}
        error={vm.validation.getError('symbol')}
        placeholder={placeholder}
        isDisabled={vm.isEditingDisabled || isDisabled}
        aria-label={ariaLabel}
        testId={testId}
      />
    )
  },
)
